import type { DateTime } from 'luxon';
import { useI18n } from 'vue-i18n';
import { useAuth } from '@/composables/firebase/auth';

type DateStyle = 'medium' | 'full' | 'long' | 'short';

interface FormatterOptions {
  useCurrencySetting: boolean;
}

const defaultCurrency = 'EUR';

export function useFormatters(options?: FormatterOptions) {
  const { t } = useI18n();

  const { localeBCP47, settings } = useAuth();
  const {
    useCurrencySetting = false,
  } = options ?? {};

  const currency = useCurrencySetting ? (settings.value?.accounting?.invoice?.currency ?? defaultCurrency) : defaultCurrency;
  const currencyFormat = new Intl.NumberFormat(localeBCP47.value, {
    style: 'currency',
    currency,
  });
  const currencySymbol: string = currencyFormat.formatToParts(0).find(({ type }) => type === 'currency')?.value ?? '€';

  return {
    currencySymbol,
    niceAmount: (amount: number): string => currencyFormat.format(amount),
    niceDate: (date: Date, dateStyle: DateStyle = 'medium'): string => new Intl.DateTimeFormat(localeBCP47.value, { dateStyle }).format(date),
    niceDateAndTime: (date: DateTime): string => t('generic.niceDateAndTime', { date: date.toFormat('dd.MM.y'), time: date.toFormat('H:m') }),
  };
}
